module.exports = __webpack_public_path__ + "static/media/villari.e3b25b34.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/villari.webp
// module id = 428
// module chunks = 0